module.exports = __webpack_public_path__ + "static/media/insight-1.3e878564.jpg";